export const LanguageCultures = [
    {
        value: 'af',
        title: 'Afrikaans',
    },
    {
        value: 'af-ZA',
        title: 'Afrikaans (South Africa)',
    },
    {
        value: 'ar',
        title: 'Arabic',
    },
    {
        value: 'ar-AE',
        title: 'Arabic (U.A.E.)',
    },
    {
        value: 'ar-BH',
        title: 'Arabic (Bahrain)',
    },
    {
        value: 'ar-DZ',
        title: 'Arabic (Algeria)',
    },
    {
        value: 'ar-EG',
        title: 'Arabic (Egypt)',
    },
    {
        value: 'ar-IQ',
        title: 'Arabic (Iraq)',
    },
    {
        value: 'ar-JO',
        title: 'Arabic (Jordan)',
    },
    {
        value: 'ar-KW',
        title: 'Arabic (Kuwait)',
    },
    {
        value: 'ar-LB',
        title: 'Arabic (Lebanon)',
    },
    {
        value: 'ar-LY',
        title: 'Arabic (Libya)',
    },
    {
        value: 'ar-MA',
        title: 'Arabic (Morocco)',
    },
    {
        value: 'ar-OM',
        title: 'Arabic (Oman)',
    },
    {
        value: 'ar-QA',
        title: 'Arabic (Qatar)',
    },
    {
        value: 'ar-SA',
        title: 'Arabic (Saudi Arabia)',
    },
    {
        value: 'ar-SY',
        title: 'Arabic (Syria)',
    },
    {
        value: 'ar-TN',
        title: 'Arabic (Tunisia)',
    },
    {
        value: 'ar-YE',
        title: 'Arabic (Yemen)',
    },
    {
        value: 'az',
        title: 'Azeri',
    },
    {
        value: 'az-Cyrl-AZ',
        title: 'Azeri (Cyrillic, Azerbaijan)',
    },
    {
        value: 'az-Latn-AZ',
        title: 'Azeri (Latin, Azerbaijan)',
    },
    {
        value: 'be',
        title: 'Belarusian',
    },
    {
        value: 'be-BY',
        title: 'Belarusian (Belarus)',
    },
    {
        value: 'bg',
        title: 'Bulgarian',
    },
    {
        value: 'bg-BG',
        title: 'Bulgarian (Bulgaria)',
    },
    {
        value: 'bs-Latn-BA',
        title: 'Bosnian (Bosnia and Herzegovina)',
    },
    {
        value: 'ca',
        title: 'Catalan',
    },
    {
        value: 'ca-ES',
        title: 'Catalan (Catalan)',
    },
    {
        value: 'cs',
        title: 'Czech',
    },
    {
        value: 'cs-CZ',
        title: 'Czech (Czech Republic)',
    },
    {
        value: 'cy-GB',
        title: 'Welsh (United Kingdom)',
    },
    {
        value: 'da',
        title: 'Danish',
    },
    {
        value: 'da-DK',
        title: 'Danish (Denmark)',
    },
    {
        value: 'de',
        title: 'German',
    },
    {
        value: 'de-AT',
        title: 'German (Austria)',
    },
    {
        value: 'de-DE',
        title: 'German (Germany)',
    },
    {
        value: 'de-CH',
        title: 'German (Switzerland)',
    },
    {
        value: 'de-LI',
        title: 'German (Liechtenstein)',
    },
    {
        value: 'de-LU',
        title: 'German (Luxembourg)',
    },
    {
        value: 'dv',
        title: 'Divehi',
    },
    {
        value: 'dv-MV',
        title: 'Divehi (Maldives)',
    },
    {
        value: 'el',
        title: 'Greek',
    },
    {
        value: 'el-GR',
        title: 'Greek (Greece)',
    },
    {
        value: 'en',
        title: 'English',
    },
    {
        value: 'en-029',
        title: 'English (Caribbean)',
    },
    {
        value: 'en-AU',
        title: 'English (Australia)',
    },
    {
        value: 'en-BZ',
        title: 'English (Belize)',
    },
    {
        value: 'en-CA',
        title: 'English (Canada)',
    },
    {
        value: 'en-GB',
        title: 'English (United Kingdom)',
    },
    {
        value: 'en-IE',
        title: 'English (Ireland)',
    },
    {
        value: 'en-JM',
        title: 'English (Jamaica)',
    },
    {
        value: 'en-NZ',
        title: 'English (New Zealand)',
    },
    {
        value: 'en-PH',
        title: 'English (Republic of the Philippines)',
    },
    {
        value: 'en-TT',
        title: 'English (Trinidad and Tobago)',
    },
    {
        value: 'en-US',
        title: 'English (United States)',
    },
    {
        value: 'en-ZA',
        title: 'English (South Africa)',
    },
    {
        value: 'en-ZW',
        title: 'English (Zimbabwe)',
    },
    {
        value: 'es',
        title: 'Spanish',
    },
    {
        value: 'es-AR',
        title: 'Spanish (Argentina)',
    },
    {
        value: 'es-BO',
        title: 'Spanish (Bolivia)',
    },
    {
        value: 'es-CL',
        title: 'Spanish (Chile)',
    },
    {
        value: 'es-CO',
        title: 'Spanish (Colombia)',
    },
    {
        value: 'es-CR',
        title: 'Spanish (Costa Rica)',
    },
    {
        value: 'es-DO',
        title: 'Spanish (Dominican Republic)',
    },
    {
        value: 'es-EC',
        title: 'Spanish (Ecuador)',
    },
    {
        value: 'es-ES',
        title: 'Spanish (Spain)',
    },
    {
        value: 'es-GT',
        title: 'Spanish (Guatemala)',
    },
    {
        value: 'es-HN',
        title: 'Spanish (Honduras)',
    },
    {
        value: 'es-MX',
        title: 'Spanish (Mexico)',
    },
    {
        value: 'es-NI',
        title: 'Spanish (Nicaragua)',
    },
    {
        value: 'es-PA',
        title: 'Spanish (Panama)',
    },
    {
        value: 'es-PE',
        title: 'Spanish (Peru)',
    },
    {
        value: 'es-PR',
        title: 'Spanish (Puerto Rico)',
    },
    {
        value: 'es-PY',
        title: 'Spanish (Paraguay)',
    },
    {
        value: 'es-SV',
        title: 'Spanish (El Salvador)',
    },
    {
        value: 'es-UY',
        title: 'Spanish (Uruguay)',
    },
    {
        value: 'es-VE',
        title: 'Spanish (Venezuela)',
    },
    {
        value: 'et',
        title: 'Estonian',
    },
    {
        value: 'et-EE',
        title: 'Estonian (Estonia)',
    },
    {
        value: 'eu',
        title: 'Basque',
    },
    {
        value: 'eu-ES',
        title: 'Basque (Basque)',
    },
    {
        value: 'fa',
        title: 'Persian',
    },
    {
        value: 'fa-IR',
        title: 'Persian (Iran)',
    },
    {
        value: 'fi',
        title: 'Finnish',
    },
    {
        value: 'fi-FI',
        title: 'Finnish (Finland)',
    },
    {
        value: 'fo',
        title: 'Faroese',
    },
    {
        value: 'fo-FO',
        title: 'Faroese (Faroe Islands)',
    },
    {
        value: 'fr',
        title: 'French',
    },
    {
        value: 'fr-BE',
        title: 'French (Belgium)',
    },
    {
        value: 'fr-CA',
        title: 'French (Canada)',
    },
    {
        value: 'fr-FR',
        title: 'French (France)',
    },
    {
        value: 'fr-CH',
        title: 'French (Switzerland)',
    },
    {
        value: 'fr-LU',
        title: 'French (Luxembourg)',
    },
    {
        value: 'fr-MC',
        title: 'French (Principality of Monaco)',
    },
    {
        value: 'gl',
        title: 'Galician',
    },
    {
        value: 'gl-ES',
        title: 'Galician (Galician)',
    },
    {
        value: 'gu',
        title: 'Gujarati',
    },
    {
        value: 'gu-IN',
        title: 'Gujarati (India)',
    },
    {
        value: 'he',
        title: 'Hebrew',
    },
    {
        value: 'he-IL',
        title: 'Hebrew (Israel)',
    },
    {
        value: 'hi',
        title: 'Hindi',
    },
    {
        value: 'hi-IN',
        title: 'Hindi (India)',
    },
    {
        value: 'hr',
        title: 'Croatian',
    },
    {
        value: 'hr-BA',
        title: 'Croatian (Bosnia and Herzegovina)',
    },
    {
        value: 'hr-HR',
        title: 'Croatian (Croatia)',
    },
    {
        value: 'hu',
        title: 'Hungarian',
    },
    {
        value: 'hu-HU',
        title: 'Hungarian (Hungary)',
    },
    {
        value: 'hy',
        title: 'Armenian',
    },
    {
        value: 'hy-AM',
        title: 'Armenian (Armenia)',
    },
    {
        value: 'id',
        title: 'Indonesian',
    },
    {
        value: 'id-ID',
        title: 'Indonesian (Indonesia)',
    },
    {
        value: 'is',
        title: 'Icelandic',
    },
    {
        value: 'is-IS',
        title: 'Icelandic (Iceland)',
    },
    {
        value: 'it',
        title: 'Italian',
    },
    {
        value: 'it-CH',
        title: 'Italian (Switzerland)',
    },
    {
        value: 'it-IT',
        title: 'Italian (Italy)',
    },
    {
        value: 'ja',
        title: 'Japanese',
    },
    {
        value: 'ja-JP',
        title: 'Japanese (Japan)',
    },
    {
        value: 'ka',
        title: 'Georgian',
    },
    {
        value: 'ka-GE',
        title: 'Georgian (Georgia)',
    },
    {
        value: 'kk',
        title: 'Kazakh',
    },
    {
        value: 'kk-KZ',
        title: 'Kazakh (Kazakhstan)',
    },
    {
        value: 'kn',
        title: 'Kannada',
    },
    {
        value: 'kn-IN',
        title: 'Kannada (India)',
    },
    {
        value: 'ko',
        title: 'Korean',
    },
    {
        value: 'kok',
        title: 'Konkani',
    },
    {
        value: 'kok-IN',
        title: 'Konkani (India)',
    },
    {
        value: 'ko-KR',
        title: 'Korean (Korea)',
    },
    {
        value: 'ky',
        title: 'Kyrgyz',
    },
    {
        value: 'ky-KG',
        title: 'Kyrgyz (Kyrgyzstan)',
    },
    {
        value: 'lt',
        title: 'Lithuanian',
    },
    {
        value: 'lt-LT',
        title: 'Lithuanian (Lithuania)',
    },
    {
        value: 'lv',
        title: 'Latvian',
    },
    {
        value: 'lv-LV',
        title: 'Latvian (Latvia)',
    },
    {
        value: 'mi-NZ',
        title: 'Maori (New Zealand)',
    },
    {
        value: 'mk',
        title: 'Macedonian',
    },
    {
        value: 'mk-MK',
        title: 'Macedonian (Former Yugoslav Republic of Macedonia)',
    },
    {
        value: 'mn',
        title: 'Mongolian',
    },
    {
        value: 'mn-MN',
        title: 'Mongolian (Cyrillic, Mongolia)',
    },
    {
        value: 'mr',
        title: 'Marathi',
    },
    {
        value: 'mr-IN',
        title: 'Marathi (India)',
    },
    {
        value: 'ms',
        title: 'Malay',
    },
    {
        value: 'ms-BN',
        title: 'Malay (Brunei Darussalam)',
    },
    {
        value: 'ms-MY',
        title: 'Malay (Malaysia)',
    },
    {
        value: 'mt-MT',
        title: 'Maltese (Malta)',
    },
    {
        value: 'nb-NO',
        title: 'Norwegian, Bokmal (Norway)',
    },
    {
        value: 'nl',
        title: 'Dutch',
    },
    {
        value: 'nl-BE',
        title: 'Dutch (Belgium)',
    },
    {
        value: 'nl-NL',
        title: 'Dutch (Netherlands)',
    },
    {
        value: 'nn-NO',
        title: 'Norwegian, Nynorsk (Norway)',
    },
    {
        value: 'no',
        title: 'Norwegian',
    },
    {
        value: 'ns-ZA',
        title: 'Northern Sotho (South Africa)',
    },
    {
        value: 'pa',
        title: 'Punjabi',
    },
    {
        value: 'pa-IN',
        title: 'Punjabi (India)',
    },
    {
        value: 'pl',
        title: 'Polish',
    },
    {
        value: 'pl-PL',
        title: 'Polish (Poland)',
    },
    {
        value: 'pt',
        title: 'Portuguese',
    },
    {
        value: 'pt-BR',
        title: 'Portuguese (Brazil)',
    },
    {
        value: 'pt-PT',
        title: 'Portuguese (Portugal)',
    },
    {
        value: 'quz-BO',
        title: 'Quechua (Bolivia)',
    },
    {
        value: 'quz-EC',
        title: 'Quechua (Ecuador)',
    },
    {
        value: 'quz-PE',
        title: 'Quechua (Peru)',
    },
    {
        value: 'ro',
        title: 'Romanian',
    },
    {
        value: 'ro-RO',
        title: 'Romanian (Romania)',
    },
    {
        value: 'ru',
        title: 'Russian',
    },
    {
        value: 'ru-RU',
        title: 'Russian (Russia)',
    },
    {
        value: 'sa',
        title: 'Sanskrit',
    },
    {
        value: 'sa-IN',
        title: 'Sanskrit (India)',
    },
    {
        value: 'se-FI',
        title: 'Sami (Northern) (Finland)',
    },
    {
        value: 'se-NO',
        title: 'Sami (Northern) (Norway)',
    },
    {
        value: 'se-SE',
        title: 'Sami (Northern) (Sweden)',
    },
    {
        value: 'sk',
        title: 'Slovak',
    },
    {
        value: 'sk-SK',
        title: 'Slovak (Slovakia)',
    },
    {
        value: 'sl',
        title: 'Slovenian',
    },
    {
        value: 'sl-SI',
        title: 'Slovenian (Slovenia)',
    },
    {
        value: 'sma-NO',
        title: 'Sami (Southern) (Norway)',
    },
    {
        value: 'sma-SE',
        title: 'Sami (Southern) (Sweden)',
    },
    {
        value: 'smj-NO',
        title: 'Sami (Lule) (Norway)',
    },
    {
        value: 'smj-SE',
        title: 'Sami (Lule) (Sweden)',
    },
    {
        value: 'smn-FI',
        title: 'Sami (Inari) (Finland)',
    },
    {
        value: 'sms-FI',
        title: 'Sami (Skolt) (Finland)',
    },
    {
        value: 'sq',
        title: 'Albanian',
    },
    {
        value: 'sq-AL',
        title: 'Albanian (Albania)',
    },
    {
        value: 'sr',
        title: 'Serbian',
    },
    {
        value: 'sr-Cyrl-BA',
        title: 'Serbian (Cyrillic) (Bosnia and Herzegovina)',
    },
    {
        value: 'sr-Cyrl-CS',
        title: 'Serbian (Cyrillic, Serbia)',
    },
    {
        value: 'sr-Latn-BA',
        title: 'Serbian (Latin) (Bosnia and Herzegovina)',
    },
    {
        value: 'sr-Latn-CS',
        title: 'Serbian (Latin, Serbia)',
    },
    {
        value: 'sv',
        title: 'Swedish',
    },
    {
        value: 'sv-FI',
        title: 'Swedish (Finland)',
    },
    {
        value: 'sv-SE',
        title: 'Swedish (Sweden)',
    },
    {
        value: 'sw',
        title: 'Kiswahili',
    },
    {
        value: 'sw-KE',
        title: 'Kiswahili (Kenya)',
    },
    {
        value: 'syr',
        title: 'Syriac',
    },
    {
        value: 'syr-SY',
        title: 'Syriac (Syria)',
    },
    {
        value: 'ta',
        title: 'Tamil',
    },
    {
        value: 'ta-IN',
        title: 'Tamil (India)',
    },
    {
        value: 'te',
        title: 'Telugu',
    },
    {
        value: 'te-IN',
        title: 'Telugu (India)',
    },
    {
        value: 'th',
        title: 'Thai',
    },
    {
        value: 'th-TH',
        title: 'Thai (Thailand)',
    },
    {
        value: 'tn-ZA',
        title: 'Tswana (South Africa)',
    },
    {
        value: 'tr',
        title: 'Turkish',
    },
    {
        value: 'tr-TR',
        title: 'Turkish (Turkey)',
    },
    {
        value: 'tt',
        title: 'Tatar',
    },
    {
        value: 'tt-RU',
        title: 'Tatar (Russia)',
    },
    {
        value: 'uk',
        title: 'Ukrainian',
    },
    {
        value: 'uk-UA',
        title: 'Ukrainian (Ukraine)',
    },
    {
        value: 'ur',
        title: 'Urdu',
    },
    {
        value: 'ur-PK',
        title: 'Urdu (Islamic Republic of Pakistan)',
    },
    {
        value: 'uz',
        title: 'Uzbek',
    },
    {
        value: 'uz-Cyrl-UZ',
        title: 'Uzbek (Cyrillic, Uzbekistan)',
    },
    {
        value: 'uz-Latn-UZ',
        title: 'Uzbek (Latin, Uzbekistan)',
    },
    {
        value: 'vi',
        title: 'Vietnamese',
    },
    {
        value: 'vi-VN',
        title: 'Vietnamese (Vietnam)',
    },
    {
        value: 'xh-ZA',
        title: 'Xhosa (South Africa)',
    },
    {
        value: 'zh-CN',
        title: 'Chinese (People\'s Republic of China)',
    },
    {
        value: 'zh-HK',
        title: 'Chinese (Hong Kong S.A.R.)',
    },
    {
        value: 'zh-CHS',
        title: 'Chinese (Simplified)',
    },
    {
        value: 'zh-CHT',
        title: 'Chinese (Traditional)',
    },
    {
        value: 'zh-MO',
        title: 'Chinese (Macao S.A.R.)',
    },
    {
        value: 'zh-SG',
        title: 'Chinese (Singapore)',
    },
    {
        value: 'zh-TW',
        title: 'Chinese (Taiwan)',
    },
    {
        value: 'zu-ZA',
        title: 'Zulu (South Africa)',
    },
];